import angular from 'angular';

export const loadModule = () =>
  angular.module('app').filter('firstChar', function firstChar() {
    return function (text) {
      return String(text).charAt(0).toUpperCase;
    };
  });
